import React, { useEffect } from 'react';
import { useStateInRef } from "../../utils/useStateInRef";
export function ScopedThemeProvider(props) {
  const {
    theme,
    children,
    className,
    testid
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    style: theme,
    "data-testid": testid
  }, children);
}
export function RootThemeProvider(props) {
  const {
    theme,
    children
  } = props;
  const getTheme = useStateInRef(theme);
  useEffect(() => {
    const root = document.documentElement;
    Object.entries(getTheme()).forEach(_ref => {
      let [key, value] = _ref;
      root.style.setProperty(key, value);
    });
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
}